export default __webpack_public_path__ + "static/media/left-arrow.cb39c5ba.svg";